// Central registry for all research reports.
// Add a new report here + a component entry in ReportPage.jsx and it shows up
// in the list automatically.

export const REPORTS = [
  {
    id: 'advanced-pms',
    tag: 'Wealth Management',
    title: 'Thinking About PMS? Read This Before You Invest',
    subtitle: 'Portfolio Management Services — In-Depth Analytical Report',
    description:
      'Structure, fees, real risks and the mistakes first-time HNI investors make. Real insights, real risks, and what no one tells you upfront.',
    highlights: [
      'PMS vs mutual funds, compared honestly',
      '10 red flags to check before you sign',
      'Fee structures and what they cost you',
    ],
    meta: '12 min read',
    stickyNote: 'Must read research before you subscribe to PMS!',
    driveLink:
      'https://drive.google.com/uc?export=download&id=1em36QeYX2M6aODkPteRYsFoyskTVsZe3',
  },
  {
    id: 'market-pe-valuation',
    tag: 'Market Valuation',
    title: 'Indian Stock Market: A Valuation Analysis Through Market PE',
    subtitle: 'Tracking Nifty 50 price-to-earnings and what it implies',
    description:
      'Historical Nifty 50 PE, the PE–return relationship, and what current valuations imply for market direction over the next 12–18 months.',
    highlights: [
      'Where the Nifty PE sits vs its 10-year average',
      'Entry PE vs 5-year forward returns',
      'Three scenarios for the next 12–18 months',
    ],
    meta: '10 min read · Jun 2026',
    stickyNote: 'Know what you are paying before you buy the index!',
    // TODO: replace with the Google Drive file id for the Market PE PDF
    driveLink:
      'https://drive.google.com/uc?export=download&id=REPLACE_WITH_MARKET_PE_FILE_ID',
  },
];

export const getReportById = (id) => REPORTS.find((r) => r.id === id);
